import React, {useEffect} from 'react'
import endImage from '../../assets/end-image.svg'

import Header from '../../components/Header'
import { Container, Content } from './styles'

const End: React.FC = () => {
  
  useEffect(() => {
    localStorage.removeItem('@CibriusPatrocinado:theme')
    localStorage.removeItem('@CibriusPatrocinado:userData')
    localStorage.removeItem('@CibriusPatrocinado:userDetails')
    localStorage.removeItem('@CibriusPatrocinado:totalBalance')
    localStorage.removeItem('@CibriusPatrocinado:receiveTypeSelected')
    localStorage.removeItem('@CibriusPatrocinado:TimeValueMonths')
    localStorage.removeItem('@CibriusPatrocinado:PercentualValuePercent')
    localStorage.removeItem('@CibriusPatrocinado:PercentualValueSaque')
    localStorage.removeItem('@CibriusPatrocinado:RendaFixaSaque')
    localStorage.removeItem('@CibriusPatrocinado:flagEdit')
    localStorage.removeItem('@CibriusPatrocinado:erroProps')
    localStorage.removeItem('@CibriusPatrocinado:participantsGroup')
    localStorage.removeItem('@CibriusPatrocinado:TimeValueYears')
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>
            Pronto! Seu pedido de adesão ao Plano Patrocinado da Cibrius foi salvo
            com sucesso!
          </strong>

          <img src={endImage} alt="endImage" />

          <p>
            Confira seu e-mail. Enviamos uma mensagem com instruções de acesso
            ao autoatendimento.
          </p>
          {/*
          <div>
            <strong>ACESSE O NOSSO SITE:</strong>
            <a href=""></a>
          </div> */}
        </Content>
      </Container>
    </>
  )
}

export default End
